// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mRsX","left":"styles_left__2Up2n"};